import { useState, useEffect } from 'react';
import {Elements} from '@stripe/react-stripe-js';
import { createPaymentIntent } from 'store/services/packageService';
import useStripe from "hooks/useStripe";
import CheckoutForm from "components/shared/PaymentForm/CheckoutForm";

const PaymentForm = ({ packageId, userId, returnUrl }) => {
  const [isReady, setIsReady] = useState(false);
  const [options, setOptions] = useState({
    clientSecret: "",
    stripeAccount: null
  })

  const stripe = useStripe(options.stripeAccount);

  useEffect(() => {
    createPayment();
  }, [])

  const createPayment = async () => {
    try {
      let data = {
        packageId: packageId,
        values: {
          currency: "USD",
          userId: userId,
        }
      }
      let response = await createPaymentIntent(data);
      if(response.success === true && response.body.clientSecret) {
        setOptions((options) => {
          return {
            ...options,
            clientSecret: response.body.clientSecret,
            stripeAccount: response.body.stripeAccount
          }
        })
        setIsReady(true);
      }
    } catch(err) {
      console.log("Error creating payment intent", err);
    }
  }


  return (
    <>
      { !isReady || !stripe ?
        <p>Loading...</p>
        :
        <Elements stripe={stripe} options={options}>
          <CheckoutForm
            onLoad={() => {}}
            returnUrl={returnUrl}
          />
        </Elements>
      }
    </>
  );
};

export default PaymentForm